<!--
  黄江 on 2017/7/21
  描述：主页
-->
<template>
  <div class="ub uw uh ubgc-while-easy ">
    <div class="ub ub-ver ub-f1">
      <!--header-->
      <div class="ub ub-ac uh-60 ubgc-main">
        <img class="ub umar-l20 uw-40 ubor-r" src="../../assets/image/logo.png" alt="">
        <div class="ub uc-while ufs-26 umar-l10 ">{{user.org?user.org.name:'智能锁销售平台'}}</div>
        <div class="ub ub-f1 ub-ac  umar-r20">
          <div class="ub ub-ac umar-l10">
            <el-radio-group v-model="isCollapse" >
              <el-radio-button :label="false">展开</el-radio-button>
              <el-radio-button :label="true">收起</el-radio-button>
            </el-radio-group>
          </div>
          <div class="ub ub-ac ub-f1 ufs-20 uh uc-while umar-l20"></div>
          <div class="ub uc-while umar-r20">
            {{user.role?user.role.name:'超级管理员'}} {{user.phone}}
            <!--<el-dropdown class="el-dropdown-link"  @command="toSelectDropdownItem">-->
              <!--<el-button type="success">-->
                <!--{{user.phone}}<i class="el-icon-caret-bottom el-icon&#45;&#45;right"></i>-->
              <!--</el-button>-->
              <!--<el-dropdown-menu slot="dropdown">-->
                <!--&lt;!&ndash;<el-dropdown-item  command="/home/personMsg">个人资料</el-dropdown-item>&ndash;&gt;-->
                <!--<el-dropdown-item  command="/home/editPword">修改密码</el-dropdown-item>-->
              <!--</el-dropdown-menu>-->
            <!--</el-dropdown>-->
          </div>
          <div class="ub uc-grey umar-r20" @click="toNewPage('/home/editPword')">
            <el-button type="warning" icon="close">修改密码</el-button>
          </div>
          <div class="ub uc-grey" @click="toNewPage('/login')">
            <el-button type="danger" icon="close">退出</el-button>
          </div>

        </div>
      </div>

      <div class="ub ub-f1">
        <!--left-menu-->
        <el-menu class="el-menu-vertical-demo " :unique-opened="true" style="background-color: #324157"   @select="toSelectMenu" :collapse="isCollapse">
          <div v-for="item in menus.data">
            <el-submenu  v-bind:index="item.code" v-if="item.children.length>0">
              <template slot="title" >
                <i :class="'iconfont ufs-14 '+item.icon"></i>
                <span>{{item.name}}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item v-bind:index="child.url" v-if="(child.code!='100110110'&&child.code!='100115105'&&child.code!='100115110') ||(user.org.code=='100100'&&(child.code=='100110110'||child.code=='100115105'||child.code=='100115110'))"

                              v-for="child in item.children">
                  <i :class="'iconfont ufs-14 icon-radiobox'"></i>
                  {{child.name}}
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item v-bind:index="item.url" v-if="item.children.length==0">
              <i :class="'iconfont ufs-14 '+item.icon"></i>
              {{item.name}}
            </el-menu-item>
          </div>
        </el-menu>

        <!--main-->
        <div class="ub ub-ver ub-f1 umain">
          <router-view></router-view>
        </div>

      </div>

    </div>
  </div>
</template>
<style>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 240px;
    min-height: 400px;
  }
</style>

<script type="text/babel">
  import router from '@/router'
  import ApiMixin from '../../assets/js/apis.js'
  export default{
      data() {
          return {
            user:{},
            menus:{
              data:[],
            },
            isCollapse:false,
          }
      },
      created() {
        this.user = JSON.parse(sessionStorage.getItem('user'))
        this.getPowerMenuList()
      },
      methods: {
        getPowerMenuList(){
          const postParam = {
            userId: this.user._id,
          }
          this.getListService('power',postParam).then((res) => {
            console.log('===========',res)
            if(res.code==0){
              let data = res.data.rows
              let treeData = []
              let parentCode = ''
              let treeItem = {}
              data= data.sort((first,next)=>{
                const tem = '000000000000000000000000000000000'
                const one = first.code+tem.substr(0,20-first.code.length)
                const two = next.code+tem.substr(0,20-next.code.length)
                return one-two
              })
              console.log('===========')
              console.log(data)
              data.forEach((item)=>{
                if(item.parentCode=='100'){
                  console.log(treeItem.hasOwnProperty('code'))
                  if(treeItem.hasOwnProperty('code')){
                    treeData.push(treeItem)
                  }
                  parentCode = 100
                  treeItem = item
                  treeItem.children=[]
                }else{
                  treeItem.children.push(item)
                }
              })
              if(treeItem.hasOwnProperty('code')){
                treeData.push(treeItem)
              }
              console.log('=====================')
              console.log(treeData)
              this.menus.data = treeData
            }
          }).catch((err) => {
            console.log('menu/power:', err)
          })
        },
        toSelectMenu(url,path){
          router.push(url)
        },
        toNewPage(path){
          if(path === '/login'){
            sessionStorage.removeItem('user')
          }
          router.push(path)
        },
        toSelectDropdownItem(item) {
          console.log(item)
          this.toNewPage(item)
        },
      },

      mixins: [ ApiMixin],
  }
</script>



// WEBPACK FOOTER //
// home.vue?164a6382